import { render } from "./PreviewBulkData.vue?vue&type=template&id=4211d8ee&scoped=true&ts=true"
import script from "./PreviewBulkData.vue?vue&type=script&lang=ts"
export * from "./PreviewBulkData.vue?vue&type=script&lang=ts"

import "./PreviewBulkData.vue?vue&type=style&index=0&id=4211d8ee&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4211d8ee"]])

export default __exports__